
import customAxios from "../../customAxios";
import { COMPANY_PAY_COMPANY_DEPOSITE } from "../../routes";

const payFinancialReportDrivers = async (endAt: string): Promise<any> => {
  const thisUrl: string = COMPANY_PAY_COMPANY_DEPOSITE + `?endAt=${endAt}T00:00:00.0Z`;
  try {
    return (await customAxios.get(thisUrl)).data;
  } catch (error: any) {
    console.log({ COMPANY_PAY_COMPANY_DEPOSITE: error });
  }
};

export default payFinancialReportDrivers;
